// Helper function to safely extract count from facet data
export const extractCount = (data: any): number => {
  if (typeof data === 'number') {
    return data;
  }
  if (typeof data === 'object' && data !== null) {
    if ('count' in data && typeof data.count === 'number') {
      return data.count;
    }
    if ('value' in data && typeof data.value === 'number') {
      return data.value;
    }
    // Try to find any numeric value in the object
    const values = Object.values(data);
    const numValue = values.find((v) => typeof v === 'number');
    return (numValue as number) || 0;
  }
  return 0;
};

// Helper function to safely extract display name - NO MODIFICATIONS
export const extractDisplayName = (data: any, fallback: string): string => {
  if (typeof data === 'string') {
    return data;
  }
  if (typeof data === 'object' && data !== null) {
    if ('value' in data) {
      return data.value;
    }
    const keys = Object.keys(data);
    if (keys.length > 0) {
      return keys[0];
    }
  }
  return fallback;
};

// Maps a listing_variant_sub_group value to its display group in the sidebar.
// Only known variant names route to Carreras/Turbos/Competition.
// Anything unrecognised returns 'Other' which is filtered out in
// HierarchicalVariantFacet — preventing stray build values (Singer, RUF,
// custom, etc.) from creating a spurious "Retromods" group.
export const mapSubGroupToTopGroup = (subGroup: string): string => {
  if (!subGroup || typeof subGroup !== 'string') {
    return 'Other';
  }

  const subGroupLower = subGroup.toLowerCase();

  // Carreras group
  if (
    subGroupLower.includes('carrera') ||
    subGroupLower.includes('rs america') ||
    subGroupLower.includes('speedster') ||
    subGroupLower.includes('america roadster')
  ) {
    return 'Carreras';
  }

  // Turbos group
  if (subGroupLower.includes('turbo')) {
    return 'Turbos';
  }

  // Competition group
  if (
    subGroupLower.includes('cup') ||
    subGroupLower.includes('gt1') ||
    subGroupLower.includes('gt2')
  ) {
    return 'Competition';
  }

  // Everything else (Singer, RUF, custom, null-ish strings, etc.)
  // returns 'Other'
  return 'Other';
};

export const formatWithDot = (value: string | number): string => {
  const num =
    typeof value === 'string' ? parseInt(value.replace(/\D/g, '')) || 0 : value;
  return num.toLocaleString('de-DE', {
    maximumFractionDigits: 0,
    useGrouping: true,
  });
};

export const roundToNearest10k = (value: number): number =>
  Math.round(value / 10000) * 10000;

export {};